import { render, staticRenderFns } from "./WidgetCreatedModal.vue?vue&type=template&id=31754b69&scoped=true&"
import script from "./WidgetCreatedModal.vue?vue&type=script&lang=js&"
export * from "./WidgetCreatedModal.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCreatedModal.vue?vue&type=style&index=0&id=31754b69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31754b69",
  null
  
)

export default component.exports